<template>
  <div class="container-custom">
    <v-form ref="form" @submit.prevent="saveHandler">
      <Breadscrumbs
        :links="[
          {
            name: 'QACenter',
            to: {
              name: 'QACenter'
            }
          },
          {
            name: 'Edit',
            to: {
              name: 'QAEdit',
              params: {
                id: $route.params.id
              }
            }
          }
        ]"
      ></Breadscrumbs>
      <!-- page-actions -->
      <div class="page-actions">
        <h2>修改項目</h2>
        <v-spacer></v-spacer>
        <button class="btn mr-5" @click="cancelHandler">
          <span>取消</span>
        </button>
        <button class="btn btn-primary" type='submit'>
          <span>儲存</span>
        </button>
      </div>
    </v-form>
    <!-- Block 問與答 -->
    <QACreateEdit></QACreateEdit>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import QACreateEdit from '@/views/G-3__QACategory/c/QACreateEdit.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';

export default {
  components: {
    Breadscrumbs,
    QACreateEdit,
    LangDialog,
  },
  data: () => ({
    isLangOpen: false,
  }),
  computed: {
    ...mapState(['lang']),
    ...mapState('resqa', ['qa']),
  },
  async created() {
    if (this.$route.params.id) {
      await this.getQA(this.$route.params.id);
    }
  },
  methods: {
    ...mapActions('resqa', {
      getQA: 'findById',
      save: 'save',
    }),
    cancelHandler() {
      this.$router.push({ name: 'QACenter' });
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.errors = [];
        if (this.$refs.form.validate()) {
          if (!this.qa.question) {
            this.errors.push('問題 required.');
          } else if (!this.qa.faq_category_id) {
            this.errors.push('分類 required.');
          } else if (!this.qa.ans) {
            this.errors.push('答案 required.');
          }
          if (this.errors.length > 0) {
            /* eslint-disable */
            alert(this.errors);
            /* eslint-disable */
            return false;
          }
          this.save(this.qa).then(() => {
            this.$router.push({ name: 'QACenter' });
          });
        }
      } else {
        this.isLangOpen = true;
      }
    },
  },
};
</script>
<style></style>